import React, { useRef, useState } from 'react';

const KEY = 'dashboardMobilePaneHeights';
const MIN = 220;
const read = () => { try { return JSON.parse(localStorage.getItem(KEY)) || {}; } catch { return {}; } };

// Phone layout card whose height can be dragged with the grip at the bottom.
export const MobileResizableCard = ({ paneId, header, children }) => {
  const [height, setHeight] = useState(() => read()[paneId] || 480);
  const [dragging, setDragging] = useState(false);
  const hRef = useRef(height);

  const start = (e) => {
    e.preventDefault();
    const startY = e.clientY;
    const startH = hRef.current;
    setDragging(true);
    const move = (ev) => {
      const next = Math.max(MIN, Math.min(window.innerHeight * 1.5, startH + ev.clientY - startY));
      hRef.current = next;
      setHeight(next);
    };
    const up = () => {
      setDragging(false);
      document.removeEventListener('pointermove', move);
      document.removeEventListener('pointerup', up);
      document.removeEventListener('pointercancel', up);
      try { localStorage.setItem(KEY, JSON.stringify({ ...read(), [paneId]: Math.round(hRef.current) })); } catch { /* ignore */ }
    };
    document.addEventListener('pointermove', move);
    document.addEventListener('pointerup', up);
    document.addEventListener('pointercancel', up);
  };

  return (
    <div className={`relative bg-card rounded-lg shadow-lg flex flex-col ${dragging ? 'ring-2 ring-purple-500' : ''}`}
      style={{ height }} data-testid={`mobile-pane-${paneId}`}>
      <div className="px-4 pt-4">{header}</div>
      <div className="flex-1 min-h-0 overflow-y-auto px-4 pb-2">{children}</div>
      <div onPointerDown={start} style={{ touchAction: 'none' }} role="separator" aria-orientation="horizontal"
        className="h-6 flex items-center justify-center cursor-row-resize shrink-0" data-testid={`mobile-pane-resize-${paneId}`}>
        <span className={`h-1.5 w-12 rounded-full transition-colors ${dragging ? 'bg-purple-500' : 'bg-slate-300 dark:bg-slate-600'}`} />
      </div>
    </div>
  );
};

export default MobileResizableCard;
